import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

import { Brenger } from "@/assets/icons/24/Brenger";
import { analyticsService } from "@/common/services/analytics/analytics.service";
import { ProductDeliveryOptionItemProps } from "@/features/product-delivery-options/components/ProductDeliveryOptionItem";
import { ProductDeliveryOptionItemRow } from "@/features/product-delivery-options/components/ProductDeliveryOptionItemRow";
import { getProductDeliveryPriceLabel } from "@/features/product-delivery-options/components/utils/product-delivery-options.utils";
import { useProductDeliveryEstimateLabel } from "@/features/product-delivery-options/hooks/useProductDeliveryEstimateLabel";
import { showModal } from "@/ui/Modal2";

export const ProductDeliveryOptionItemBrenger = ({
  option,
  loading,
}: ProductDeliveryOptionItemProps) => {
  const { t } = useTranslation();
  const { locale } = useRouter();

  const estimate = useProductDeliveryEstimateLabel(option);
  const { label, isFree } = getProductDeliveryPriceLabel(option, t, locale);

  const handleReadMoreClick = () => {
    showModal("pdp-details-modal", {
      title: t("shipping-options:product-shipping-option-brenger-title"),
      text: t("shipping-options:product-shipping-option-brenger-body"),
    });

    /** Trigger `readmore_brenger_pdp` event. */
    analyticsService.trackReadMoreBrengerPdp();
  };

  return (
    <ProductDeliveryOptionItemRow
      method="brenger"
      icon={<Brenger className="size-6 shrink-0 text-brand-500" />}
      title={t("pdp:pdp-usp-shipping-title-courier-brenger")}
      subtitle={estimate}
      priceLabel={label}
      isFree={isFree}
      loading={loading}
      onInfoClick={handleReadMoreClick}
    />
  );
};
